import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output
} from '@angular/core';
import { TypographyComponent } from 'components';
import {
	PreviewSlide,
	ReportDateRange,
	SlideType
} from '../../../../models/preview/preview.models';
import { ReportContentItem } from '../../../../services/report-settings.service';

@Component({
	standalone: true,
	selector: 'app-placeholder-slide',
	template: `
		<div class="placeholder-slide">
			<typography variant="p/sm_medium" class="placeholder-slide__label">
				{{ title }}
			</typography>
			<typography variant="p/xs_regular" class="placeholder-slide__note">
				This section will be available in a future update.
			</typography>
		</div>
	`,
	styles: [
		`
			.placeholder-slide {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				min-height: 200px;
				gap: 8px;
				color: #9ca3af;
			}

			.placeholder-slide__note {
				color: #d1d5db;
			}
		`
	],
	imports: [TypographyComponent]
})
export class PlaceholderSlideComponent implements OnChanges {
	@Input() item!: ReportContentItem;
	@Input() brandId!: string;
	@Input() dateRange!: ReportDateRange;
	@Input() themeColor: string | null = null;
	@Input() editorMode = false;
	@Output() slideBuilt = new EventEmitter<PreviewSlide>();

	title = '';

	ngOnChanges(): void {
		if (!this.item) return;
		this.title = this.item.title || this.item.id;
		this.slideBuilt.emit({
			id: this.item.id,
			slideType: this.item.id as SlideType,
			title: this.title,
			widgets: []
		});
	}
}
